export const getUserData = () => JSON.parse(localStorage.getItem('user')) || {};

export const setUserData = (data) => {
    localStorage.setItem('user', JSON.stringify(data));
};
export const removeUserData = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
};
